interface PageLoaderProps {
  label?: string;
}

export function PageLoader({ label = 'Loading…' }: PageLoaderProps) {
  return (
    <div className="flex min-h-[40vh] items-center justify-center" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-4">
        {/* Orbital spinner — echoes the logo motif */}
        <svg width="56" height="56" viewBox="0 0 56 56" aria-hidden="true">
          <circle
            cx="28"
            cy="28"
            r="22"
            fill="none"
            stroke="#1B3A6B"
            strokeOpacity="0.12"
            strokeWidth="2"
          />
          <circle
            cx="28"
            cy="28"
            r="22"
            fill="none"
            stroke="url(#loader-grad)"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeDasharray="40 200"
            className="origin-center animate-spin"
            style={{ animationDuration: '1.6s' }}
          />
          <defs>
            <linearGradient id="loader-grad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#E87722" />
              <stop offset="100%" stopColor="#F5A623" />
            </linearGradient>
          </defs>
        </svg>
        <p className="text-sm text-brand-navy-500">{label}</p>
      </div>
    </div>
  );
}
